import { RatesService, RatesProvider, HttpService } from '@lk/api'

export const makeRatesService = (http: HttpService, baseUrl: string) =>
  new RatesService(new RatesProvider(http, baseUrl))
